import { briefList } from '@/mocks/home';
import SectionHeading from '@/components/feature/SectionHeading';

const catStyle: Record<string, string> = {
  独家: 'bg-primary-100 text-primary-800',
  进展: 'bg-secondary-100 text-secondary-900',
  核实: 'bg-accent-100 text-accent-900',
  深扒: 'bg-primary-100 text-primary-800',
  线索: 'bg-accent-100 text-accent-900',
  证据: 'bg-secondary-100 text-secondary-900',
  实锤: 'bg-primary-500 text-background-50',
  线人: 'bg-secondary-100 text-secondary-900',
};

export default function DailyBrief() {
  return (
    <section id="brief" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-[1360px] px-4 md:px-6 lg:px-10">
        <SectionHeading
          eyebrow="BULLETIN"
          title="今日爆料速报"
          desc="短讯按时间倒序滚动更新，每条都标注了处理状态。想先扫一遍梗概，从这里开始最省时间。"
          actionHref="#ranking"
          actionLabel="查看完整热榜"
        />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-10 gap-y-0">
          {briefList.map((item, index) => (
            <a
              key={item.id}
              href="#dig"
              className="group flex items-center gap-4 py-4 border-b border-background-200 hover:border-primary-300 transition-colors"
            >
              <span className="w-14 shrink-0 text-xs text-foreground-400 tabular-nums">{item.time}</span>
              <span
                className={`shrink-0 px-2 py-0.5 rounded text-[11px] font-medium ${catStyle[item.cat] ?? 'bg-background-200 text-foreground-700'}`}
              >
                {item.cat}
              </span>
              <span className="flex-1 min-w-0 text-sm md:text-[15px] text-foreground-800 leading-snug group-hover:text-primary-600 transition-colors line-clamp-1">
                {item.title}
              </span>
              {item.hot && (
                <span className="w-5 h-5 shrink-0 flex items-center justify-center text-primary-500">
                  <i className="ri-fire-fill text-base" />
                </span>
              )}
              <span className="hidden sm:flex w-4 h-4 shrink-0 items-center justify-center text-foreground-300 group-hover:text-primary-500 transition-colors">
                <i className="ri-arrow-right-s-line text-lg" />
              </span>
              <span className="sr-only">{index + 1}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}